import { silentClient as browserClient } from '@api/client';
import type { components } from '@api/swagger';
import { getXhData } from '@api/utils';
import { API_BASE_URI } from '@components/env';
import { EventCategory, type EventType } from '@shared/types/stats';

import { browser } from '$app/environment';

export async function getGtm(referrer: string, pathname: string) {
    return browserClient.GET('/stats/gtm', {
        params: {
            query: {
                referrer,
                pathname,
            },
        },
    });
}

export async function sendRoomUserStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['room_user'] | null,
    isDesktop: boolean
) {
    return sendStats(
        type,
        EventCategory.RoomUser,
        isDesktop,
        categoryData ? { room_user: categoryData } : undefined
    );
}

export async function sendPmStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['pm'] | null,
    isDesktop: boolean
) {
    return sendStats(
        type,
        EventCategory.Pm,
        isDesktop,
        categoryData ? { pm: categoryData } : undefined
    );
}

export async function sendRoomModelStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['room_model'] | null,
    isDesktop: boolean
) {
    return sendStats(
        type,
        EventCategory.RoomModel,
        isDesktop,
        categoryData ? { room_model: categoryData } : undefined
    );
}

export async function sendPaymentsStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['payments'] | null,
    isDesktop: boolean
) {
    return sendStats(
        type,
        EventCategory.Payments,
        isDesktop,
        categoryData ? { payments: categoryData } : undefined
    );
}

export async function sendRegistrationStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['registration'] | null,
    isDesktop: boolean
) {
    return sendStats(
        type,
        EventCategory.Registration,
        isDesktop,
        categoryData ? { registration: categoryData } : undefined
    );
}

export async function sendVerificationStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['verification'],
    isDesktop: boolean
) {
    return sendStats(type, EventCategory.Verification, isDesktop, { verification: categoryData });
}

export async function sendLoginStats(
    type: EventType,
    isDesktop: boolean
) {
    return sendStats(type, EventCategory.Login, isDesktop);
}

export async function sendUserGiftStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['gift'],
    isDesktop: boolean
) {
    return sendStats(type, EventCategory.RoomUserGift, isDesktop, { gift: categoryData });
}

export async function sendModelGiftStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['gift'],
    isDesktop: boolean
) {
    return sendStats(type, EventCategory.RoomModelGift, isDesktop, { gift: categoryData });
}

export async function sendConnectionLostStats(
    type: EventType,
    categoryData: components['schemas']['CategoryData']['connection_lost'],
    isDesktop: boolean
) {
    return sendStats(type, EventCategory.ConnectionLost, isDesktop, { connection_lost: categoryData });
}

export async function sendStats(
    type: EventType,
    category: EventCategory,
    isDesktop: boolean,
    categoryData?: components['schemas']['CategoryData']
) {
    let xhData = undefined;

    if (browser) {
        xhData = getXhData();
    }

    const body = {
        type,
        category,
        url: document.location.href,
        referrer: document.referrer || null,
        isDesktop,
        categoryData,
        xhData,
    };

    if ('sendBeacon' in window.navigator) {
        return window.navigator.sendBeacon(API_BASE_URI + '/stats/send', JSON.stringify(body));
    }
    return browserClient.POST('/stats/send', {
        body,
    }).catch((e) => console.error(e));

}
